import { render } from "./CreditsPage.vue?vue&type=template&id=5f7e8b32&scoped=true"
import script from "./CreditsPage.vue?vue&type=script&lang=js"
export * from "./CreditsPage.vue?vue&type=script&lang=js"

import "./CreditsPage.vue?vue&type=style&index=0&id=5f7e8b32&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f7e8b32"]])

export default __exports__